"use client";

import { Html } from "@/Components";
import { TestSectionProps } from "@/Templates/SectionsProps";
import { FC, ReactNode } from "react";
import HomeTwelveTestSectionGenerated, {
  HomeTwelveTestSectionGeneratedProps,
} from "../Sections/_generated/HomeTwelveTestSection.generated";
import { buildGeneratedSectionProps } from "./generated-section-renderer";
import { CenterOptions } from "@/Helpers/CenterOptions";

function renderHtmlValue(value?: string | null): ReactNode | undefined {
  if (!value) {
    return undefined;
  }

  return <Html value={value} />;
}

function getPrimaryPhone(props: TestSectionProps): string | undefined {
  return (
    props.pageData.CommonData.Tels?.find((tel) => Boolean(tel)) ?? undefined
  );
}

function getPrimaryPhoneHref(props: TestSectionProps): string | undefined {
  const phone = getPrimaryPhone(props);
  if (!phone) {
    return undefined;
  }

  return `tel:${phone}`;
}

function getButtonVisible(props: TestSectionProps): boolean | undefined {
  if (
    props.setting.ButtonDisplayStatus === undefined ||
    props.setting.ButtonDisplayStatus === null
  ) {
    return undefined;
  }

  return (
    props.setting.ButtonDisplayStatus.Key ===
    CenterOptions.Enum.Status.Active.key
  );
}

const GeneratedTestSection: FC<TestSectionProps> = (props) => {
  const defaults =
    buildGeneratedSectionProps<HomeTwelveTestSectionGeneratedProps>(
      "HomeTwelveTestSection",
    );
  const primaryPhone = getPrimaryPhone(props);
  const primaryPhoneHref = getPrimaryPhoneHref(props);

  return (
    <HomeTwelveTestSectionGenerated
      {...defaults}
      sectionDiv0Div0H20H2Text={
        props.setting.Title ?? defaults.sectionDiv0Div0H20H2Text
      }
      sectionDiv0Div0P0PText={
        renderHtmlValue(props.setting.Description) ??
        defaults.sectionDiv0Div0P0PText
      }
      sectionDiv0Div1Div0Div1Link0LinkText={
        primaryPhone ?? defaults.sectionDiv0Div1Div0Div1Link0LinkText
      }
      sectionDiv0Div1Div0Div1Link0LinkHref={
        primaryPhoneHref ?? defaults.sectionDiv0Div1Div0Div1Link0LinkHref
      }
      sectionDiv0Div1Div0Div1Link0LinkVisible={Boolean(primaryPhone)}
      sectionDiv0Div1Link0LinkHref={
        props.setting.ButtonLink ?? defaults.sectionDiv0Div1Link0LinkHref
      }
      sectionDiv0Div1Link0Span1SpanText={
        props.setting.ButtonText ?? defaults.sectionDiv0Div1Link0Span1SpanText
      }
      sectionDiv0Div1Link0LinkVisible={getButtonVisible(props)}
    />
  );
};

export default GeneratedTestSection;
